import { createStyles, Theme, withStyles } from "@material-ui/core";
import { Paper, Grid, Button } from '@material-ui/core';
import React from 'react';

import ghaDashboardStyles from './ghaDashboard.module.css';
import commonStyles from '../../common/common.module.css';
import rightArrow from '../../../assets/rightArrow.svg';
import bulb from '../../../assets/bulb.svg';
import DriverQueue from "../../../models/DriverQueue";
import moment from "moment";

const styles = (theme: Theme) =>

  createStyles({
  });

interface ServingDashboardProps {
   classes: any;
   serving: Array<DriverQueue>; 
   type: string;    
};

const servingDashboard = (props: ServingDashboardProps) => {
  const drivers = props.serving.map((driver: DriverQueue, index: number) => {
    return (
      <Grid item xs={12} className={ ghaDashboardStyles.gridItem } key={ index }>
        <Grid container alignItems='stretch' className={ `${ commonStyles.positionRelative } ${ ghaDashboardStyles.servingOuter }` }>
          <Grid item xs={6} className={ `${ commonStyles.positionRelative } ${ commonStyles.fvMiddle } ${ ghaDashboardStyles.userDetails }` }>
            <div className={ ghaDashboardStyles.infoTypeWrapper }>
              <small className={ ghaDashboardStyles.smallTextType }>{driver.info.type == 'import' ? 'Pick Up' : 'Drop Off'}</small>
            </div>
            <div className={ ghaDashboardStyles.infoTypeWrapper }>
              <small className={ ghaDashboardStyles.smallTextAirline }>{ driver.info.airlines ? driver.info.airlines.join(', ') : ''
                }</small>
            </div>
            <div className={ ghaDashboardStyles.nameWrapper }>
              <span className={ ghaDashboardStyles.name }>{ `${driver.info.first_name} ${driver.info.last_name}` }</span>
            </div>
            <div className={ ghaDashboardStyles.companyWrapper }>
              <small className={ ghaDashboardStyles.smallText }>{ driver.info.company }</small>
            </div>
          </Grid>
          <img src={rightArrow} alt='right-arrow' className={ ghaDashboardStyles.arrowImg } />
          <Grid item xs={6} className={ `${ commonStyles.fMiddle } ${ commonStyles.positionRelative } ${ ghaDashboardStyles.counterDetails }` }>
            <span className={ ghaDashboardStyles.counterNo }>{ props.type == 'dashboard' && driver.info.counter ? driver.info.counter : props.type == 'whs' && driver.info.dock ?  driver.info.dock : '' }</span>
            <small className={ `${ commonStyles.textCenter } ${ ghaDashboardStyles.smallText }` }>Wait Time  { moment(new Date).diff(driver.check_in, 'minutes') } mins</small>
            { driver.info.bulb && 
              <div className={ ghaDashboardStyles.bulb }>
                <img src={bulb} alt='bulb' className={ `${ ghaDashboardStyles.bulbImg }` } />
                <div className={ ghaDashboardStyles.bulbBliking }></div>
              </div> }
          </Grid>
        </Grid>
      </Grid>
    )
  })

  return (
    <div className={ `${ commonStyles.wrapper } ${ ghaDashboardStyles.wrapper } ${ commonStyles.mb0 }` }>
    <h3 className={ `${ commonStyles.header } ${ ghaDashboardStyles.header }` }> Now Serving</h3>
    <Grid container spacing={5} className={ ghaDashboardStyles.componentHeight }>
      { drivers }
    </Grid>
  </div>
  )
}

export default withStyles(styles)(servingDashboard);